/***
     Copyright (c) 2019-2023 Markadoc Corp. All Rights Reserved.
     This file and all related source code are protected under US and 
     International Copyright and Patent laws.
 ***/
//import { bootstrapApplication } from '@angular/platform-browser';
//import { importProvidersFrom } from '@angular/core';
//import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

import "hammerjs";

/* eslint-disable */

// 1. Add the polyfill first so it runs before everything else
/******
const TypelessPromise = Promise as any;
if (!TypelessPromise.withResolvers) {
  TypelessPromise.withResolvers = function withResolvers() {
    let a, b, c = new this((resolve, reject) => {
      a = resolve;
      b = reject;
    });
    return { resolve: a, reject: b, promise: c };
  };
}
*****/

/*****
bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(NgxExtendedPdfViewerModule),
    // other providers...
  ],
});
****/


if (environment.production) {
  enableProdMode();
}

/** web-version-config-on **/
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
/** end-web-version-config-on **/

/** cordova-version-config-off
let onDeviceReady = () => {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
};

document.addEventListener('deviceready', onDeviceReady, false);
end-cordova-version-config-on **/
